import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Alert } from 'reactstrap'

import { SignUpLink } from './SignUp'
import { PasswordForgetLink } from './PasswordForget'
import { auth } from '../../firebase'
import * as routes from '../../constants/routes'
import * as layout from '../../constants/layout'
import { DivWithMargin } from '../StyledComponents/Fillers'
import { SignInFormular, InputTop, InputBottom, SignInCard, SignInCardContent, SignUpLink as Link } from '../StyledComponents/Authentication'
import { NotFoundContainer } from '../StyledComponents/NotFoundPage'

const SignInPage = ({ history }) =>
    (
        <NotFoundContainer>
            <SignInForm history={history} />
        </NotFoundContainer>
    )

const byPropKey = (propertyName, value) => () => ({
    [propertyName]: value,
})

const INITIAL_STATE = {
    email: '',
    password: '',
    error: null,
}

class SignInForm extends Component {
    constructor(props) {
        super(props)

        this.state = { ...INITIAL_STATE }
    }

    onSubmit = (event) => {
        const {
            email,
            password,
        } = this.state

        const {
            history,
        } = this.props

        auth.doSignInWithEmailAndPassword(email, password)
            .then(() => {
                this.setState(() => ({ ...INITIAL_STATE }))
                history.push(routes.REDIRECT_CONTROLLER)
            })
            .catch((error) => {
                this.setState(byPropKey('error', error))
            })

        event.preventDefault()
    }

    render() {
        const {
            email,
            password,
            error,
        } = this.state

        const isInvalid =
            password === '' ||
            email === ''

        return (
            <SignInCard>
                <SignInCardContent>
                    <SignInFormular className="text-center" onSubmit={this.onSubmit}>
                        <h1 className="h3 mb-3 font-weight-normal">Login</h1>
                        <label htmlFor="inputEmail" className="sr-only">Email Adresse</label>
                        <InputTop
                            value={email}
                            onChange={event => this.setState(byPropKey('email', event.target.value))}
                            type="email"
                            id="inputEmail"
                            className="form-control"
                            placeholder="Email Adresse"
                            required
                            autofocus
                        />

                        <label htmlFor="inputPassword" className="sr-only">Passwort</label>
                        <InputBottom
                            value={password}
                            type="password"
                            id="inputPassword"
                            className="form-control"
                            placeholder="Passwort"
                            onChange={event => this.setState(byPropKey('password', event.target.value))}
                            required
                        />

                        <button className="btn btn-lg btn-primary btn-block" disabled={isInvalid} type="submit">
                            Einloggen
                        </button>

                        { error && <DivWithMargin top={layout.MARGIN_TOP} bottom={layout.MARGIN_BOTTOM}><Alert color="danger">{error.message}</Alert></DivWithMargin> }

                        <DivWithMargin top="10" className="small">
                            <SignUpLink className="text-primary" />
                            {' oder '}
                            <PasswordForgetLink className="text-primary" />
                        </DivWithMargin>
                    </SignInFormular>
                </SignInCardContent>
            </SignInCard>
        )
    }
}

const SignInLink = () => <Link to={routes.SIGN_IN}>Zum Login</Link>

export default withRouter(SignInPage)

export {
    SignInForm,
    SignInLink
}



// WEBPACK FOOTER //
// ./src/components/userManagement/SignIn.js